import {API_BASE_URL} from '@/shared/config'

interface TokenResponse {
  token: string
}

interface TokenRequest {
  roomId: string
  participantName: string
  participantIdentity?: string
}

/**
 * Fetch a LiveKit access token from the backend
 */
export async function fetchToken({
  roomId,
  participantName,
  participantIdentity,
}: TokenRequest): Promise<TokenResponse> {
  const response = await fetch(`${API_BASE_URL}/livekit/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      room_id: roomId,
      participant_name: participantName,
      participant_identity: participantIdentity,
    }),
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({error: 'Failed to fetch token'}))
    console.error('Failed to fetch token', error)
    throw new Error(error.error || 'Failed to fetch token')
  }

  return response.json()
}
